import { Theme } from "@mui/material/styles";
import InputFields from "./inputField";
import { Buttons, IconButtons } from "./button";
import { Drawer } from "./drawer";
import Table from "./table";
import Dialog from "./dialog";

const baselineBodyStyles = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: '"Poppins", sans-serif',
      },
    },
  },
};

const OverridesComponents = (theme: Theme) => ({
  ...baselineBodyStyles,
  ...InputFields(theme),
  ...Buttons(theme),
  ...IconButtons(theme),
  ...Drawer(theme),
  ...Table(theme),
  ...Dialog(theme),
});

export default OverridesComponents;
